export interface ICachingSpecification {
	ttl: number | undefined;
}
